export default "__VITE_ASSET__D1ZPjGJn__"